import Navbar from "../components/Navbar";
import PageHero from "../components/PageHero";
import Stats from "../components/Stats";
import About from "../components/About";
import PricingTiers from "../components/PricingTiers";
import Process from "../components/Process";
import Gallery from "../components/Gallery";
import CuratedReviews from "../components/CuratedReviews";
import StudioMap from "../components/StudioMap";
import CeramicEducation from "../components/CeramicEducation";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import {
  SEO,
  localBusinessSchema,
  serviceSchema,
  faqSchema,
  breadcrumbSchema,
} from "../components/SEO";
import { BRAND } from "../mock";

const FAQS = [
  {
    q: "How much does ceramic coating cost in Mississauga?",
    a: "At Jester Werks our flagship 2-layer ceramic coating with a 1-stage paint correction included is currently $550. a limited content-based offer for select vehicles we feature on our channels. The regular price is $1,500. Final pricing varies by vehicle size and the level of paint correction required, and we provide a written, no-obligation quote within 24 hours.",
  },
  {
    q: "What is the best ceramic coating in Mississauga?",
    a: "Jester Werks is Mississauga's most-reviewed ceramic coating studio with 250+ verified 5-star Google reviews. We install a premium 2-layer Gtechniq system. Gtechniq Crystal Serum Light as the hard base coat, topped with Gtechniq EXO v5 for high-gloss hydrophobics. hand-applied in a climate-controlled bay and warrantied in writing for 5 years.",
  },
  {
    q: "Where can I get ceramic coating near me in Mississauga?",
    a: "Our Mississauga studio serves drivers from every neighbourhood. Port Credit, Streetsville, Erin Mills, Meadowvale, Cooksville, Lorne Park, Clarkson, Square One, City Centre, Applewood, Hurontario, Dixie, Heartland, Churchill Meadows, Erindale, Lakeview, Mineola, Sheridan and Malton. Complimentary pickup and delivery is available within Mississauga on packages over $1,000.",
  },
  {
    q: "How long does ceramic coating last on a car?",
    a: "With proper maintenance washes, our 2-layer ceramic coating lasts a full 5 years on the paint and includes free annual maintenance inspections to keep the hydrophobics performing at their peak.",
  },
  {
    q: "Do I need paint correction before ceramic coating?",
    a: "Yes. Ceramic coating locks in whatever is underneath, so we always perform paint correction first to remove swirl marks, scratches and oxidation. Our $550 Mississauga offer already includes a 1-stage paint correction. multi-stage corrections are available for an additional charge depending on paint condition.",
  },
  {
    q: "What does the $550 ceramic coating special in Mississauga include?",
    a: "Our Mississauga ceramic coating special includes: full decontamination prep, a 1-stage paint correction, the 2-layer Crystal Serum Light + EXO v5 system, a free window coating ($150 value) for better rain visibility and water-flicking, a written 5-year warranty, and a documented before/after report. It is a limited, content-based offer for vehicles we feature on our channels.",
  },
  {
    q: "Is Jester Werks the highest-rated ceramic coating shop in Mississauga?",
    a: "Yes. Jester Werks is ranked #1 on Google for ceramic coating in Mississauga with 250+ verified 5-star reviews, 1,500+ cars coated, 20K+ followers on Instagram, and over 1 million content views every month. We are the most-reviewed and most transparent ceramic coating studio in the city.",
  },
  {
    q: "Where is Jester Werks ceramic coating studio located in Mississauga?",
    a: "Our Mississauga studio is located at 5156 Oscar Peterson Blvd, Mississauga, ON L5M 7W4. easily accessible from the QEW, 401, 403, 407 and Hurontario St. We serve all of Mississauga plus Toronto, Etobicoke, Oakville, Brampton, Burlington, Vaughan and the entire GTA.",
  },
  {
    q: "How long does a ceramic coating service take?",
    a: "A full paint correction + 2-layer ceramic coating in our Mississauga studio typically takes 2 to 4 days depending on the size and condition of the vehicle. We never rush. every panel is inspected under multiple lights and the coating gets a controlled cure before delivery.",
  },
  {
    q: "Do you offer pickup and delivery in Mississauga?",
    a: "Yes. We offer complimentary pickup and delivery anywhere in Mississauga (Port Credit, Streetsville, Erin Mills, Meadowvale, Cooksville, Lorne Park, Clarkson, Square One, Erindale and beyond) on coating packages over $800.",
  },
];

const NEIGHBOURHOODS = [
  "Port Credit", "Streetsville", "Erin Mills", "Meadowvale", "Cooksville",
  "Lorne Park", "Clarkson", "Lakeview", "Mineola", "Sheridan", "Square One",
  "City Centre", "Applewood", "Hurontario", "Dixie", "Heartland",
  "Churchill Meadows", "Erindale", "Malton", "Mississauga Valleys",
];

export default function CeramicMississauga() {
  const url = `${BRAND.url}/ceramic-coating-mississauga`;
  return (
    <div className="grain bg-jester-deep text-white">
      <SEO
        title="Ceramic Coating Mississauga | #1 Rated Studio | Jester Werks"
        description="Ceramic coating Mississauga from $550. Jester Werks is the #1 rated, most-reviewed ceramic coating studio in Mississauga. 250+ verified Google reviews, 1,500+ cars coated, 5-year warranty, free window coating included. Serving Port Credit, Streetsville, Erin Mills, Square One & all of the GTA. Call (647) 646-7223."
        canonical={url}
        schemas={[
          localBusinessSchema(),
          serviceSchema({
            name: "Ceramic Coating Mississauga",
            description:
              "Premium 2-layer Gtechniq ceramic coating service in Mississauga, ON. Hand-applied Gtechniq Crystal Serum Light + EXO v5 with 1-stage paint correction included, 5-year warranty, free window coating. Mississauga's most-reviewed ceramic coating studio.",
            areaServed: [
              "Mississauga", "Port Credit", "Streetsville", "Erin Mills",
              "Meadowvale", "Cooksville", "Lorne Park", "Clarkson", "Square One",
              "Erindale", "Churchill Meadows", "Toronto", "Oakville", "Brampton", "Etobicoke",
            ],
            offers: "550",
          }),
          faqSchema(FAQS),
          breadcrumbSchema([
            { name: "Home", url: `${BRAND.url}/` },
            { name: "Ceramic Coating Mississauga", url },
          ]),
        ]}
      />
      <Navbar />
      <PageHero
        kicker="Mississauga · #1 Rated · 250+ Google Reviews"
        h1="CERAMIC COATING"
        h1Accent="MISSISSAUGA."
        marker="locked in for 5 years."
        description="Mississauga's #1 rated and most-reviewed Gtechniq ceramic coating studio. Hand-applied 2-layer Gtechniq ceramic with 1-stage paint correction included. now from $550 (regularly $1,500) with a free window coating. Trusted by 1,500+ Mississauga drivers."
        city="Mississauga"
        bgImage="https://images.unsplash.com/photo-1588508050172-e51cf614535c"
        secondaryCta={{ label: "View Packages", href: "#pricing" }}
      />

      {/* Educational infographics block. moved to top so visitors learn immediately */}
      <CeramicEducation />

      {/* Pricing packages. placed right after the education block */}
      <PricingTiers city="Mississauga" />

      {/* SEO copy block. keyword rich, Mississauga-specific */}
      <section className="relative py-24 md:py-28">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-acid mb-5 font-label">
           . #1 in Mississauga
          </div>
          <h2 className="font-display text-4xl md:text-5xl leading-[1] mb-8">
            The <span className="text-jester">#1 ceramic coating</span>{" "}
            studio in Mississauga.
          </h2>
          <div className="text-white/75 text-lg leading-relaxed space-y-5">
            <p>
              Jester Werks is the <strong className="text-white">most-reviewed
              ceramic coating studio in Mississauga</strong>. ranked #1 on
              Google for ceramic coating Mississauga with{" "}
              <strong className="text-acid">250+ verified five-star
              reviews</strong>, 1,500+ cars coated since 2023, 20,000+
              Instagram followers and over 1 million monthly content views. We
              are owner-operated, hand-finish every car, and back every
              coating in writing.
            </p>
            <p>
              Our flagship Mississauga ceramic coating package pairs Gtechniq's
              flagship hard base coat (<em>Gtechniq Crystal Serum Light</em>)
              with a high-gloss hydrophobic top coat (<em>Gtechniq EXO v5</em>)
             a true two-layer Gtechniq system, hand-applied panel by panel
              in our climate-controlled, dust-filtered Mississauga bay. The
              Gtechniq coating bonds chemically to your factory clear coat,
              creating a glass-deep liquid shield that repels water, salt,
              brake dust, tree sap, bird droppings and UV oxidation for a full
              five years.
            </p>
            <p>
              Right now we're running a limited{" "}
              <strong className="text-acid">$550 content-based ceramic
              coating offer</strong> (regularly $1,500) for select Mississauga
              vehicles we feature on our channels. The package includes a full
              decontamination prep, 1-stage paint correction, the complete
              2-layer ceramic system, a{" "}
              <strong className="text-white">free window coating</strong>{" "}
              ($150 value) for better rain visibility, a documented
              before/after report and a written 5-year warranty. Spots are
              limited.
            </p>
            <p>
              We serve every neighbourhood in Mississauga.{" "}
              <strong className="text-white">
                Port Credit, Streetsville, Erin Mills, Meadowvale, Cooksville,
                Lorne Park, Clarkson, Lakeview, Mineola, Sheridan, Square One,
                City Centre, Applewood, Hurontario, Dixie, Heartland,
                Churchill Meadows, Erindale, Malton
              </strong>{" "}
              and the Mississauga Valleys. We also serve drivers from{" "}
              <a href="/ceramic-coating-toronto" className="text-acid underline underline-offset-4 hover:text-white">
                Toronto
              </a>
              , Oakville, Brampton, Etobicoke, Burlington, Vaughan and the
              broader GTA. with complimentary pickup and delivery within 25
              km on packages over $800.
            </p>
            <p>
              Whether you're searching for{" "}
              <em className="text-white/90">"ceramic coating Mississauga"</em>,{" "}
              <em className="text-white/90">"best ceramic coating Mississauga"</em>,{" "}
              <em className="text-white/90">"ceramic coating near me"</em> or{" "}
              <em className="text-white/90">"Gtechniq Mississauga"</em>, you've
              landed on the highest-rated, most transparent ceramic coating
              studio in the city. Read{" "}
              <a href="/reviews" className="text-acid underline underline-offset-4 hover:text-white">
                250+ five-star Google reviews
              </a>
              , then request your free written quote. delivered in under 24
              hours.
            </p>
          </div>
        </div>
      </section>

      {/* Neighbourhoods served. internal SEO + GMB local pack signal */}
      <section className="relative py-16 border-y border-white/5 bg-[#0c0119]" data-testid="neighbourhoods-section">
        <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
          <div className="text-xs uppercase tracking-[0.3em] text-acid mb-4 font-label">
           Mississauga neighbourhoods we serve
          </div>
          <h3 className="font-display text-2xl md:text-3xl mb-8">
            Ceramic coating <span className="text-jester">across all of Mississauga.</span>
          </h3>
          <div className="flex flex-wrap justify-center gap-2 md:gap-3">
            {NEIGHBOURHOODS.map((n, i) => (
              <span
                key={i}
                data-testid={`neighbourhood-${i}`}
                className="px-4 py-2 rounded-full border border-white/10 bg-jester-card text-sm text-white/80 hover:border-acid/50 hover:text-acid transition-colors"
              >
                {n}
              </span>
            ))}
          </div>
          <p className="mt-8 text-sm text-white/50">
            Free pickup &amp; delivery on packages over $1,000 anywhere in Mississauga.
          </p>
        </div>
      </section>

      <Stats />
      <About />
      <Process />
      <Gallery />
      <CuratedReviews />
      <StudioMap />
      <FAQ items={FAQS} />
      <Contact />
      <Footer />
    </div>
  );
}
